import { render, staticRenderFns } from "./ButtonLabelComplexe.vue?vue&type=template&id=7b409fd2&scoped=true"
import script from "./ButtonLabelComplexe.vue?vue&type=script&lang=ts"
export * from "./ButtonLabelComplexe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b409fd2",
  null
  
)

export default component.exports